import styled from 'styled-components';

import { flexStyle } from '../../css';

export const PageContainer = styled.div`
  ${flexStyle}

  width: 100%;
`;
